import { BoundingBoxOptions, type GeographicTargetingState } from '@openx/types/targeting/geographic.ts';
import { sumLengths } from '@openx/utils/lib/sumLengths.ts';
import isEmpty from 'lodash/isEmpty';
import { useMemo } from 'react';

export const useGeographicItemsData = (targetingParams: GeographicTargetingState) => {
  const { bounding_box, circles_v2, includes, excludes, excludes_subset, location_source } = targetingParams;

  const includesKeys = useMemo(() => Object.keys(includes).filter(key => !isEmpty(includes[key])), [includes]);
  const excludesKeys = useMemo(() => Object.keys(excludes).filter(key => !isEmpty(excludes[key])), [excludes]);

  const includesCount = sumLengths(includesKeys, key => includes[key].length);
  const excludesCount = sumLengths(excludesKeys, key => excludes[key].length);
  const excludesSubsetCount = excludes_subset.length;
  const locationCount = includesCount + excludesCount + excludesSubsetCount;
  const locationsSwitchState = !includesCount && !!excludesCount;

  const isCirclesOptionSelected = !!circles_v2.length;
  const isLocationSourceSelected = !!location_source.val.size;
  const isBoundingBoxEmpty = !bounding_box[BoundingBoxOptions.LATMIN] && !bounding_box[BoundingBoxOptions.LONGMIN];

  return {
    excludes,
    includes,
    includesKeys,
    excludesKeys,
    locationCount,
    locationsSwitchState,
    isCirclesOptionSelected,
    isLocationSourceSelected,
    isBoundingBoxEmpty,
  };
};
